/** @format */
import { css } from 'styled-components';

const baseStyles = () => css`
    position: relative;
    display: inline-block;
    cursor: pointer;

    .badge {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
        transform: translate(50%, -50%);
    }
    .icon {
        cursor: pointer;
    }
`;

export const styles = () => css`
    ${baseStyles()}
`;
